import { ecoIcon } from "./fuelAssets";
import FuelType from "entities/fuelType";

export default function fuelEcoIcon(fuelType: FuelType) {
  if (fuelType !== FuelType.Other) {
    return ecoIcon;
  }
}
